<template>
    <div class="relative inline-block">
        <img
            :src="url"
            :alt="filename"
            class="h-16 w-16 rounded-lg border border-gray-200 object-cover shadow-sm"
        />
        <button
            type="button"
            class="absolute -right-2 -top-2 flex h-5 w-5 cursor-pointer items-center justify-center rounded-full bg-gray-800 text-white shadow transition hover:bg-gray-900 active:scale-90 disabled:cursor-not-allowed disabled:opacity-50"
            :disabled="disabled"
            :aria-label="t('vue.ai_chat_remove_image')"
            :title="t('vue.ai_chat_remove_image')"
            @click="$emit('remove')"
        >
            <XMarkIcon class="h-3.5 w-3.5" />
        </button>
    </div>
</template>

<script lang="ts" setup>
import { XMarkIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";

withDefaults(
    defineProps<{
        url: string;
        filename?: string;
        disabled?: boolean;
    }>(),
    { filename: "", disabled: false },
);

defineEmits<{ (event: "remove"): void }>();

const { t } = useTranslations();
</script>
